import { SolicitacaoModel } from './../../model/solicitacao/solicitacao.model';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ControleoModel } from 'app/model/solicitacao/controle.model';
import { _throw as throwError } from 'rxjs/observable/throw';
import { Router } from '@angular/router';
import GenericReturn from '../../model/generic/generic-return.model';
import {IndicarConteudoDTO} from '../../model/solicitacao/indicarCaixa.model';
import {CaixaConteudoDTOModel} from '../../model/solicitacao/caixaConteudoDTO.model';

@Injectable()
export class SolicitacaoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient,
    private router: Router) { }

  adicionarSolicitacao(solicitacao: SolicitacaoModel): Observable<SolicitacaoModel> {
    return this.httpClient.post<SolicitacaoModel>(this.apiURL + '/adicionar-solicitacao', solicitacao, this.httpOptions);
  }

  getSolicitacao(solicitacaoId: Number): Observable<SolicitacaoModel> {
    return this.httpClient.get<SolicitacaoModel>(this.apiURL + `/listar-solicitacao/${solicitacaoId}`, this.httpOptions);
  }

  getSolicitacoesCliente(clienteId: Number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(this.apiURL + `/listar-solicitacoes/${clienteId}`, this.httpOptions);
  }

  getSolicitacoesClienteInterface(clienteId: Number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(this.apiURL + `/listar-solicitacoes-interface/${clienteId}`, this.httpOptions);
  }

  addCaixasSolicitacao(idsCaixa: Array<Number>, solicitacaoId: Number): Observable<Array<any>> {
    return this.httpClient.post<Array<any>>(this.apiURL + `/adicionar-caixa-solicitacao/${solicitacaoId}`, idsCaixa, this.httpOptions);
  }

  removeCaixasSolicitacao(idsCaixa: Array<Number>, solicitacaoId: Number) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));
    return this.httpClient.post(this.apiURL + `/remover-caixa-solicitacao/${solicitacaoId}`, idsCaixa, { headers, responseType: 'text' });
  }

  listarCaixasSolicitacao(solicitacaoId: Number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(this.apiURL + `/listar-caixas-solicitacao/${solicitacaoId}`, this.httpOptions);
  }

  listarCaixasSolicitacaoRealocacao(solicitacaoId: Number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(this.apiURL + `/listar-caixas-solicitacao-realocacao/${solicitacaoId}`, this.httpOptions);
  }

  pesquisaAvancadaSolicitacao(clienteId: number, pesquisaCaixa: Array<any>): Observable<Array<any>> {
    return this.httpClient.post<Array<any>>(this.apiURL + `/pesquisa-avancada-solicitacao/${clienteId}`, pesquisaCaixa, this.httpOptions);
  }

  listarModulos(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(this.apiURL + '/listar-modulos-get', this.httpOptions);
  }

  listarComponentesModulo(idModulo): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(this.apiURL + '/listar-componentes-modulo-sp/'+idModulo, this.httpOptions);
  }


  listarAlocacao(componenteId): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(this.apiURL + '/listar-componentes-alocacao/'+componenteId, this.httpOptions);
  }

  alocarCaixa(body) {

    return this.httpClient.post(this.apiURL + '/componente/alocar-recipiente', body, this.httpOptions);
  }

  finalizarSolicitacaoManual(body){

    return this.httpClient.post(this.apiURL + '/solicitacao-implantacao-finalizar', body, this.httpOptions);
  }

  processarRequisicao(body){

    return this.httpClient.post(this.apiURL + '/solicitacao-requisicao-processar', body, this.httpOptions);
  }

  processarDevolucao(body){

    return this.httpClient.post(this.apiURL + '/solicitacao-devolucao-processar', body, this.httpOptions);
  }

  processarSolicitacaoAutomatica(body){

    return this.httpClient.post(this.apiURL + '/solicitacao-alocacao-automatica', body, this.httpOptions);
  }

  excluirSolicitacao(solicitacaoId: Number) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + `/excluir-solicitacao/${solicitacaoId}`, { headers, responseType: 'text' });
  }

  cancelarSolicitacao(solicitacaoId: Number) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + `/cancelar-solicitacao/${solicitacaoId}`, { headers, responseType: 'text' });
  }


  listarCaixasPendeteRecuperacao(){

    return this.httpClient.get(this.apiURL + '/caixas-pendente-recuperacao', this.httpOptions);
  }


  listarCaixasPendeteDevolucao(){

    return this.httpClient.get(this.apiURL + '/caixas-pendente-devolucao', this.httpOptions);
  }

  recuperarCaixaUnica(body){

    return this.httpClient.post(this.apiURL + '/caixa-recuperar-unica', body, this.httpOptions);
  }

  devolverCaixaUnica(body){

    return this.httpClient.post(this.apiURL + '/caixa-devolver-unica', body, this.httpOptions);
  }

  caixasEmRecuperacao(body){

    return this.httpClient.post(this.apiURL + '/caixas-em-recuperacao-user', body, this.httpOptions);
  }

  caixasEmDevolucao(body){

    return this.httpClient.post(this.apiURL + '/caixas-em-devolucao-user', body, this.httpOptions);
  }

  recuperarRecipientesUser(body){

    return this.httpClient.post(this.apiURL + '/solicitacao-recuperar-recipientes-user', body, this.httpOptions);
  }

  devolverRecipientesUser(body){

    return this.httpClient.post(this.apiURL + '/solicitacao-devolver-recipientes-user', body, this.httpOptions);
  }


  alocacoesComponente(componenteId){

    return this.httpClient.get(this.apiURL + '/caixa-posicoes-componente/'+componenteId, this.httpOptions);
  }

  caixasAlocadasSolicitacao(solicitacaoId){

    return this.httpClient.get(this.apiURL + '/caixas-alocadas-solicitacao/'+solicitacaoId, this.httpOptions);

  }

  salvarMultiplasAlocacoes(body): any{

    return this.httpClient.post(this.apiURL + '/caixas-salvar-alocacoes-multiplas', body, this.httpOptions);
  }

  salvarMultiplasAlocacoesAndFinalizar(body){

    return this.httpClient.post(this.apiURL + '/caixas-salvar-alocacoes-multiplas-finalizar', body, this.httpOptions);
  }

  criarControle(idsCaixa): Observable<ControleoModel> {
    return this.httpClient.post<ControleoModel>(this.apiURL + '/criar-controle', idsCaixa, this.httpOptions);
  }

  listarControles(idsCaixa): Observable<ControleoModel[]> {
    return this.httpClient.post<ControleoModel[]>(this.apiURL + '/controles-caixas', idsCaixa, this.httpOptions);
  }

  controleUnico(controleId, tipo): Observable<ControleoModel> {
    return this.httpClient.get<ControleoModel>(this.apiURL + `/controle-unico/${controleId}/${tipo}`, this.httpOptions);
  }

  listarCaixasPendenteRealocacao(solicitacaoId){

    return this.httpClient.get(this.apiURL + '/caixas-listar-pendente-realocacao/'+solicitacaoId, this.httpOptions);

  }



  realocarMultiplascaixas(body){

    return this.httpClient.post(this.apiURL + '/caixas-realocar-multiplas', body, this.httpOptions);
  }


  finalizarRealocacao(body){

    return this.httpClient.post(this.apiURL + '/finalizar-solicitacao-realocacao', body, this.httpOptions);
  }

  relatorioCaixasRealocadas(solicitacaoId: Number): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + `/relatorio-caixas-realocadas/${solicitacaoId}`, this.httpOptions);
  }

  buscarSolicitacoesPorMinhasEmpresas(): Observable<GenericReturn<any>> {
    return this.httpClient.get<GenericReturn<any>>(this.apiURL + '/solicitar-conteudo/solicitacoes', this.httpOptions);
  }

  buscarSolicitacoesPorMinhasEmpresasParaDevolucao(): Observable<GenericReturn<any>> {
    return this.httpClient.get<GenericReturn<any>>(this.apiURL + '/solicitar-conteudo/solicitacoes-devolucao', this.httpOptions);
  }

  buscarSolicitacoesUnica(id: number): Observable<GenericReturn<any>> {
    return this.httpClient.get<GenericReturn<any>>(this.apiURL + `/solicitar-conteudo/${id}`, this.httpOptions);
  }
  handleError(error: HttpErrorResponse) {
    if (error.status === 403) {
      this.router.navigate(['403']);
    }
    return throwError(error);
  }

  requisitarConteudo(objetoBody: IndicarConteudoDTO): Observable<GenericReturn<any>> {
    return this.httpClient.post<GenericReturn<any>>(this.apiURL + `/solicitar-conteudo/requisitar-conteudo`, objetoBody, this.httpOptions);
  }

  buscarConteudoSolicitacao(solicitacaoId: number): Observable<GenericReturn<CaixaConteudoDTOModel[]>> {
    return this.httpClient
      .get<GenericReturn<CaixaConteudoDTOModel[]>>
      (this.apiURL + `/solicitar-conteudo/pesquisar-conteudo-solicitacao/${solicitacaoId}`, this.httpOptions);
  }

  buscarConteudoSolicitacaoRequisicaoPendente(solicitacaoId: number): Observable<GenericReturn<CaixaConteudoDTOModel[]>> {
    return this.httpClient
      .get<GenericReturn<CaixaConteudoDTOModel[]>>
      (this.apiURL + `/solicitar-conteudo/pesquisar-conteudo-solicitacao-pendente-requisicao/${solicitacaoId}`, this.httpOptions);
  }

  buscarConteudoSolicitacaoEmRecuperacao(solicitacaoId: number): Observable<GenericReturn<CaixaConteudoDTOModel[]>> {
    return this.httpClient
      .get<GenericReturn<CaixaConteudoDTOModel[]>>
      (this.apiURL + `/solicitar-conteudo/pesquisar-conteudo-solicitacao-em-recuperacao/${solicitacaoId}`, this.httpOptions);
  }

  processarSolicitacaoConteudo(solicitacaoId: number): Observable<GenericReturn<any>> {
    return this.httpClient.post<GenericReturn<any>>(this.apiURL + `/solicitar-conteudo/processar-solic-conteudo/${solicitacaoId}`, null, this.httpOptions);
  }

  buscarSolicitacoesConteudo(): Observable<GenericReturn<any[]>> {
    return this.httpClient.get<GenericReturn<any[]>>(this.apiURL + `/solicitar-conteudo/buscar-solicitacoes-conteudo-check`, this.httpOptions);
  }

  recuperarConteudoUnico(body: any): Observable<GenericReturn<any>>{

    return this.httpClient.post<GenericReturn<any>>(this.apiURL + '/recuperar-conteudo-unico', body, this.httpOptions);
  }

  recuperarConteudos(solicitacaoId: number): Observable<GenericReturn<any>> {
    return this.httpClient.post<GenericReturn<any>>(this.apiURL + `/recuperar-conteudos/${solicitacaoId}`, null, this.httpOptions);
  }

  devolverConteudoUnico(body: any): Observable<GenericReturn<any>>{
    return this.httpClient.post<GenericReturn<any>>(this.apiURL + '/devolver-conteudo-unico', body, this.httpOptions);
  }

  buscarConteudosDevolucaoEmpresa(): Observable<GenericReturn<any>>{
    return this.httpClient.get<GenericReturn<any>>(this.apiURL + '/buscar-conteudos-devolucao-empresas', this.httpOptions);
  }

  processarSolicitacaoDevolucaoConteudo(solicitacaoId: number): Observable<GenericReturn<any>> {
    return this.httpClient.post<GenericReturn<any>>(this.apiURL + `/solicitar-conteudo/processar-solic-devolucao-conteudo/${solicitacaoId}`, null, this.httpOptions);
  }

  buscarConteudoSolicitacaoEmDevolucao(): Observable<GenericReturn<CaixaConteudoDTOModel[]>> {
    return this.httpClient
      .get<GenericReturn<CaixaConteudoDTOModel[]>>
      (this.apiURL + `/solicitar-conteudo/buscar-conteudos-em-devolucao`, this.httpOptions);
  }

  devolverConteudos(): Observable<GenericReturn<any>> {
    return this.httpClient.post<GenericReturn<any>>(this.apiURL + `/devolver-conteudos`, null, this.httpOptions);
  }
  
  downloadRelatorioSolicitacoes(clienteId: number, pesquisaCaixa: Array<any>) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.post(this.apiURL + `/download-relatorio-solicitacao/${clienteId}`, pesquisaCaixa, {headers,  responseType: 'blob'});
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/solicitacao/solicitacao.service.ts